(function () {
  if (window.__upsellTileInit) return;
  window.__upsellTileInit = true;

  const origFetch = window.fetch;

  let lastCartKey = 0;
  let delayTimer = null;
  let isProcessing = false;

  function openCart() {
    document.dispatchEvent(new CustomEvent('cart:open'));
    document.querySelector('[data-cart-open]')?.click();
    document.querySelector('cart-drawer')?.open?.();
  }

  async function getCartKey() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return (cart.items || []).reduce((sum, i) => sum + i.quantity, 0);
    } catch (e) {
      return 0;
    }
  }

  function startDelay() {
    clearTimeout(delayTimer);
    delayTimer = setTimeout(() => {
      openCart();
    }, 700);
  }

  window.fetch = async function (url, opts) {
    const isAddToCart =
      typeof url === 'string' && url.includes('/cart/add');

    if (isAddToCart && opts && opts.body && !isProcessing) {
      try {
        isProcessing = true;

        const tiles = document.querySelectorAll('.upsell-tile-wrap');
        let upsellItems = [];

        tiles.forEach(tile => {
          const data = window.Alpine?.$data?.(tile);

          if (!data || !data.checked || !data.products) return;

          // --- TOWEL 1 (always required) ---
          const p1 = data.products[data.productIndex];
          if (!p1 || !p1.variants?.length) return;

          const v1 = p1.variants[data.variantIndex ?? 0];
          if (v1?.id) {
            upsellItems.push({
              id: v1.id,
              quantity: 1,
              properties: {
                _upsell: 'true',
                _discount: data.discount === 100 ? 'FREE' : data.discount + '% off'
              }
            });
          }

          // --- TOWEL 2 (only if enabled) ---
          if (data.enableSecondSelection) {
            const p2 = data.products[data.productIndex2];
            if (p2 && p2.variants?.length) {
              const v2 = p2.variants[data.variantIndex2 ?? 0];
              if (v2?.id) {
                upsellItems.push({
                  id: v2.id,
                  quantity: 1,
                  properties: {
                    _upsell: 'true',
                    _discount: data.discount === 100 ? 'FREE' : data.discount + '% off'
                  }
                });
              }
            }
          }
        });

        if (upsellItems.length > 0) {
          if (typeof opts.body === 'string') {
            const body = JSON.parse(opts.body);

            if (body.items) {
              body.items = [...body.items, ...upsellItems];
            } else {
              body.items = [
                {
                  id: parseInt(body.id),
                  quantity: parseInt(body.quantity) || 1,
                  properties: body.properties || {}
                },
                ...upsellItems
              ];

              delete body.id;
              delete body.quantity;
              delete body.properties;
            }

            opts.body = JSON.stringify(body);
          }

          else if (opts.body instanceof FormData) {
            let index = 0;
            opts.body.forEach((value, key) => {
              const match = key.match(/items\[(\d+)\]/);
              if (match) {
                index = Math.max(index, parseInt(match[1]) + 1);
              }
            });

            upsellItems.forEach((item, i) => {
              const idx = index + i;
              opts.body.append(`items[${idx}][id]`, item.id);
              opts.body.append(`items[${idx}][quantity]`, item.quantity);
              Object.entries(item.properties || {}).forEach(([key, val]) => {
                opts.body.append(`items[${idx}][properties][${key}]`, val);
              });
            });
          }
        }

      } catch (e) {
        console.warn('Upsell cart intercept error:', e);
      } finally {
        setTimeout(() => {
          isProcessing = false;
        }, 300);
      }
    }

    const response = await origFetch.apply(this, arguments);

    if (isAddToCart) {
      setTimeout(async () => {
        const newKey = await getCartKey();
        if (newKey !== lastCartKey) {
          lastCartKey = newKey;
          startDelay();
        }
      }, 100);
    }

    return response;
  };
})();